import React from 'react'
import reactCSS from 'reactcss'
import { ChromePicker } from 'react-color'
import { ReactComponent as EyeDropperSVG } from '../SVG/eyedropper-svgrepo-com.svg';



class ColorPicker extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            displayColorPicker: false,
            color: this.props.color,
        };
    }


    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChange = (color) => {
        this.setState({ color: color.hex })
        this.props.onChangeColor(color.hex);
    };

    handleEyeDropper = async () => {
        const eyeDropper = new window.EyeDropper();

        try {
            const selectedColor = await eyeDropper.open();
            this.setState({ color: selectedColor.sRGBHex });
            this.props.onChangeColor(selectedColor.sRGBHex);
        } catch (err) {
            console.log('color selection cancelled');
        }
    }

    render() {

        const styles = reactCSS({
            'default': {
                color: {
                    width: '24px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `${this.state.color}`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '10',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });

        return (
            <div>
                <div style={styles.swatch} onClick={this.handleClick}>
                    <div style={styles.color} />
                </div>
                <EyeDropperSVG style={{ width: "25px", height: "25px" }} onClick={this.handleEyeDropper.bind(this)} />

                {
                    this.state.displayColorPicker ? <div style={styles.popover}>
                        <div style={styles.cover} onClick={this.handleClose} />
                        <ChromePicker color={this.state.color} onChange={this.handleChange} />
                    </div> : null
                }

            </div >
        )
    }
}

export default ColorPicker;